import React, {Fragment, useEffect, useState} from 'react';
import {Checkbox, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup} from '@mui/material';
import {TextFieldDebounce} from '../../../controls/agyle/textFieldDebounce';
import Divider from '@mui/material/Divider';
import makeStyles from '@mui/styles/makeStyles';
import AgyleBlockSwitch from '../../../components/ui/switch/agyleBlockSwitch';
import AgyleAccordion from '../../../components/ui/accordion/agyleAccordion';
import moment from 'moment';
import {useDispatch, useSelector} from 'react-redux';
import Formatter from '../../../util/formatter';
import {hasOneOfPermission, Permissions, user} from '../../../store/reducers/user';
import Notes from '../../../util/notes';
import AgyleTextField from '../../../components/ui/fields/agyleTextField';
import Button from '@mui/material/Button';
import {useTranslation} from 'react-i18next';

const useStyles = makeStyles((theme) => ({

    divider: {
        width: '100%',
        // alignItems: 'center',
        margin: '5px',
    },

    blockSwitch: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },

    textField: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },

    provideDetailsLabel: {
        alignItems: 'center',
    },

    radio: {
        width: '100%',
        minWidth: '100%',
    },

    mandatory: {
        fontWeight: 'bold',
        color: '#e06666',
    },
    clearButton: {
        border: '1px solid #2180f7',
        height: '25px',
        placeSelf: 'center',
    },

}));

const activityItems = [
    {
        id: 'toileting',
        field: 'toileting',
        label: 'Toileting',
    },
    {
        id: 'washing',
        field: 'washing',
        label: 'Washing',
    },
    {
        id: 'dressing',
        field: 'dressing',
        label: 'Dressing',
    },
    {
        id: 'meal',
        field: 'meal',
        label: 'Meal preparation',
    },
    {
        id: 'feeding',
        field: 'feeding',
        label: 'Feeding',
    },
    {
        id: 'shopping',
        field: 'shopping',
        label: 'Shopping',
    },


];

const FrailtyForm = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation();

    // Selectors
    const userObject = useSelector(user);
    const tester = Formatter.formatUserFullName(userObject);

    const [frailtyForm, setFrailtyForm] = useState({
        lives: '',
        withFamilyDetails: '',
        otherDetails: '',

        liveIn: '',
        flatDetails: '',
        liveInOtherDetails: '',
        wardenControlledProperty: '',
        furtherInformation: '',
        wardenCover: '',

        lift: false,
        liftDetails: '',
        warden: false,

        beenAdapted: false,
        beenAdaptedDetails: '',

        housebound: false,
        houseboundDetails: '',

        carers: false,
        whoProvideCare: {
            formal: false,
            privatelyFunded: false,
            informal: false,
            familyFriends: false,
            other: false,
        },
        otherProvideCareSpecify: '',
        informalDetails: '',
        careFrequency: '',

        patient: '',
        withHelpOf: '',
        withHelpOfDetails: '',
        patientOtherDetails: '',

        cognitive: false,
        diagnosis: false,
        diagnosisDetails: '',
        cognitiveDetails: '',

        health: "",
        financial: "",
        powerOfAttorneyHealthYes: "",
        relationshipHealthYes: "",
        powerOfAttorneyHealthNo: "",
        relationshipHealthNo: "",
        powerOfAttorneyFinancialYes: "",
        relationshipFinancialYes: "",
        powerOfAttorneyFinancialNo: "",
        relationshipFinancialNo: "",

        personProvidingInformation: '',
        personProvidingInformationOther: '',

        feeding: '',
        feedingDetails: '',
        meal: '',
        mealDetails: '',
        shopping: '',
        shoppingDetails: '',
        washing: '',
        washingDetails: '',
        dressing: '',
        dressingDetails: '',
        toileting: '',
        toiletingDetails: '',
        passport: false,
    });

    const [accordionExpandedState, setAccordionExpandedState] = useState({
        home: true,
        mobility: true,
        cognition: true,
        activity: true,
    });

    useEffect(() => {
        if (props.patient?.studies?.frailtyForm) {
            setFrailtyForm(props.patient?.studies?.frailtyForm);
        }
    }, []);

    useEffect(() => {
        if (frailtyForm.patient !== 'transfersOnly') {
            setFrailtyForm(pr => ({
                ...pr,
                withHelpOfDetails: '',
                withHelpOf: '',
            }));
        }
    }, [frailtyForm.patient]);

    useEffect(() => {
        if (props.onDisableSubmit) {
            props.onDisableSubmit(isSubmitDisabled() || !canSaveForm())
        }
        if (props.onSubmitFunction) {
            props.onSubmitFunction(handleSaveForm);
        }
    }, [frailtyForm, userObject]);

    const handleChangeRadio = (event) => {
        const {name, value} = event.target;
        setFrailtyForm(pr => ({
            ...pr,
            [name]: value,
        }));
    };

    const handleChangeTextField = (event) => {
        const {name, value} = event.target;
        setFrailtyForm(pr => ({
            ...pr,
            [name]: value,
        }));
    };

    const handleChangeBlockSwitch = (name) => {
        setFrailtyForm(pr => ({
            ...pr,
            [name]: !pr[name],
        }));
    };

    const handleChangeCheckbox = (event, objectKey) => {
        const {name, checked} = event.target;
        setFrailtyForm((pr) =>
            ({
                ...pr,
                [objectKey]: {
                    ...pr[objectKey],
                    [name]: checked,
                },
            }));
    };

    const handleChangeAccordion = (param) => {
        setAccordionExpandedState((pr) =>
            ({
                ...pr,
                [param]: !pr[param],
            }));
    };

    const handleChangeNull = (name) => {
        setFrailtyForm(pr => ({
            ...pr,
            [name]: '',
        }));
    };

    const isSubmitDisabled = () => {

        let submitDisabled = false;
        if (dispatch(hasOneOfPermission([Permissions.AGYLE_CAN_MANAGE_FRAILITY]))) {
            if (frailtyForm.lives === 'other' && frailtyForm.otherDetails === '') {
                submitDisabled = true;
            }
            if (frailtyForm.liveIn === 'otherLiveIn' && frailtyForm.liveInOtherDetails === '') {
                submitDisabled = true;
            }
            if (frailtyForm.whoProvideCare.other && frailtyForm.otherProvideCareSpecify === '') {
                submitDisabled = true;
            }
            if (frailtyForm.houseboundDetails === '') {
                submitDisabled = true;
            }
            if (frailtyForm.personProvidingInformation === 'other' && frailtyForm.personProvidingInformationOther === '') {
                submitDisabled = true;
            }
        } else {
            submitDisabled = true;
        }

        return submitDisabled;
    };

    const canSaveForm = () => {
        return dispatch(hasOneOfPermission([Permissions.AGYLE_CAN_MANAGE_FRAILITY]));
    };

    const handleSaveForm = () => {
        const objectToSave = {
            ...frailtyForm,
            timeStamp: moment().toISOString(),
            by: tester,
        };
        let dataArray = [{
            name: 'studies.frailtyForm',
            value: objectToSave,
            noteType: 'studies.frailtyForm',
            noteToAdd: Notes.getFrailtyFormNote(objectToSave),
        }];

        props.onChange(dataArray);
    };

    const renderActivityItems = () => {
        return activityItems.map(({id, field, label}) => {
            return (
                <Fragment key={id}>
                    <Grid item xs={2}>
                        <FormLabel className={classes.label}>
                            {t(label)}:
                        </FormLabel>
                    </Grid>

                    <Grid item xs={5}>
                        <FormControl>
                            <RadioGroup
                                row
                                name={field}
                                onChange={handleChangeRadio}
                                value={frailtyForm[field]}
                            >
                                <FormControlLabel
                                    value="yes"
                                    control={<Radio/>}
                                    label={t('Yes')}
                                />

                                <FormControlLabel
                                    value="no"
                                    control={<Radio/>}
                                    label={t('No')}
                                />

                                <FormControlLabel
                                    value="na"
                                    control={<Radio/>}
                                    label={t('N/A')}
                                />

                                <FormControlLabel
                                    value="unknown"
                                    control={<Radio/>}
                                    label={t('Unknown')}
                                />

                                <Button
                                    className={classes.clearButton}
                                    onClick={() => handleChangeNull([field])}
                                >
                                    {t('CLEAR')}
                                </Button>
                            </RadioGroup>
                        </FormControl>
                    </Grid>

                    <Grid item xs={5}>
                        <TextFieldDebounce
                            // disabled={isFormDisabled}
                            name={`${field}Details`}
                            maxRows={25}
                            label={t('Provide details...')}
                            multiline
                            agyleRefresh
                            fullWidth
                            onChange={handleChangeTextField}
                            value={frailtyForm[`${field}Details`]}
                            variant="outlined"
                            changeValueTrigger
                            noBorder={false}
                            withNewBackground
                        />
                    </Grid>
                </Fragment>
            );
        });
    };

    return (
        // <AgyleDialog
        //     onSave={handleSaveForm}
        //     disableSubmit={isSubmitDisabled()}
        //     open={props.open}
        //     width="lg"
        //     fullWidth
        //     closeButtonOnHeader
        //     title={t("Frailty")}
        //     onClose={props.onClose}
        // >
        <>
            <AgyleAccordion
                className={classes.gridContainer}
                expanded={accordionExpandedState.home}
                onChange={() => handleChangeAccordion('home')}
                label="Home Circumstances"
                formBackground
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <FormControl>
                            <FormLabel className={classes.label}>
                                {t('Who does the patient live with?')}
                            </FormLabel>

                            <RadioGroup
                                row
                                name="lives"
                                onChange={handleChangeRadio}
                                value={frailtyForm.lives}
                            >
                                <FormControlLabel
                                    value="alone"
                                    control={<Radio/>}
                                    label={t('Alone')}
                                />
                                <FormControlLabel
                                    value="withSpouseOrPartner"
                                    control={<Radio/>}
                                    label={t('With spouse or partner')}
                                />
                                <FormControlLabel
                                    value="withFamily"
                                    control={<Radio/>}
                                    label={t('With Family')}
                                />
                                <FormControlLabel
                                    value="other"
                                    control={<Radio/>}
                                    label={t('Other')}
                                />
                                <Button
                                    className={classes.clearButton}
                                    onClick={() => handleChangeNull('lives')}
                                >
                                    {t('CLEAR')}
                                </Button>
                            </RadioGroup>
                        </FormControl>
                    </Grid>

                    {frailtyForm.lives === 'withFamily' &&
                        <Grid item xs={12}>
                            <FormLabel>
                                {t('Provide details')}
                            </FormLabel>

                            <TextFieldDebounce
                                // disabled={isFormDisabled}
                                name="withFamilyDetails"
                                maxRows={25}
                                multiline
                                agyleRefresh
                                fullWidth
                                onChange={handleChangeTextField}
                                value={frailtyForm.withFamilyDetails}
                                variant="outlined"
                                changeValueTrigger
                                noBorder={false}
                                withNewBackground
                            />
                        </Grid>
                    }

                    {frailtyForm.lives === 'other' &&
                        <Grid item xs={12}>
                            <FormLabel className={frailtyForm.otherDetails ? classes.label : classes.mandatory}>
                                {t('Provide further information:')}
                                {!frailtyForm.otherDetails && '*'}
                            </FormLabel>

                            <AgyleTextField
                                fullWidth
                                name="otherDetails"
                                // className={classes.input}
                                maxRows={25}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtyForm.otherDetails}
                                variant="outlined"
                                error={!frailtyForm.otherDetails}
                                noBorder={false}
                                withNewBackground
                            />
                        </Grid>
                    }

                    <Divider className={classes.divider}/>

                    <Grid item xs={12}>
                        <FormControl>
                            <FormLabel className={classes.label}>
                                {t('Lives in a?')}
                            </FormLabel>

                            <RadioGroup
                                row
                                name="liveIn"
                                onChange={handleChangeRadio}
                                value={frailtyForm.liveIn}
                            >
                                <FormControlLabel
                                    value="houseWithStairs"
                                    control={<Radio/>}
                                    label={t('House with stairs')}
                                />

                                <FormControlLabel
                                    value="flat"
                                    control={<Radio/>}
                                    label={t('Flat')}
                                />

                                <FormControlLabel
                                    value="bungalow"
                                    control={<Radio/>}
                                    label={t('Bungalow')}
                                />

                                <FormControlLabel
                                    value="careHome"
                                    control={<Radio/>}
                                    label={t('Care home')}
                                />

                                <FormControlLabel
                                    value="nursingHome"
                                    control={<Radio/>}
                                    label={t('Nursing home')}
                                />

                                <FormControlLabel
                                    value="wardenControlledProperty'"
                                    control={<Radio/>}
                                    label={t('Warden Controlled property')}
                                />

                                <FormControlLabel
                                    value="otherLiveIn"
                                    control={<Radio/>}
                                    label={t('Other')}
                                />

                                <Button
                                    className={classes.clearButton}
                                    onClick={() => handleChangeNull('liveIn')}
                                >
                                    {t('CLEAR')}
                                </Button>
                            </RadioGroup>
                        </FormControl>
                    </Grid>

                    {frailtyForm.liveIn === 'flat' &&
                        <>
                            <Grid item xs={12}>
                                <FormLabel>
                                    {t('What level i.e. ground floor, first floor?')}
                                </FormLabel>
                                <TextFieldDebounce
                                    // disabled={isFormDisabled}
                                    name="flatDetails"
                                    maxRows={25}
                                    multiline
                                    agyleRefresh
                                    fullWidth
                                    onChange={handleChangeTextField}
                                    value={frailtyForm.flatDetails}
                                    variant="outlined"
                                    changeValueTrigger
                                    noBorder={false}
                                    withNewBackground
                                />
                            </Grid>

                            <Grid item xs={6} className={classes.blockSwitch}>
                                <FormLabel>
                                    {t('Is there a Lift?')}
                                </FormLabel>

                                <AgyleBlockSwitch
                                    value={frailtyForm.lift}
                                    onChange={() => handleChangeBlockSwitch('lift')}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <TextFieldDebounce
                                    // disabled={isFormDisabled}
                                    name="liftDetails"
                                    maxRows={25}
                                    label={t('Enter additional information if required')}
                                    multiline
                                    fullWidth
                                    agyleRefresh
                                    onChange={handleChangeTextField}
                                    value={frailtyForm.liftDetails}
                                    variant="outlined"
                                    changeValueTrigger
                                    noBorder={false}
                                    withNewBackground
                                />
                            </Grid>
                        </>
                    }

                    {frailtyForm.liveIn === 'wardenControlledProperty' &&
                        <>
                            <Grid item xs={12}>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="wardenControlledProperty"
                                        onChange={handleChangeRadio}
                                        value={frailtyForm.wardenControlledProperty}
                                    >
                                        <FormControlLabel
                                            value="wardeControlledFlat"
                                            control={<Radio/>}
                                            label={t('Warden controlled flat')}
                                        />
                                        <FormControlLabel
                                            value="wardenControlledBungalow"
                                            control={<Radio/>}
                                            label={t('Warden controlled bungalow')}
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <FormLabel>
                                    {t('Further information')}
                                </FormLabel>

                                <TextFieldDebounce
                                    // disabled={isFormDisabled}
                                    name="furtherInformation"
                                    maxRows={25}
                                    multiline
                                    agyleRefresh
                                    fullWidth
                                    onChange={handleChangeTextField}
                                    value={frailtyForm.furtherInformation}
                                    variant="outlined"
                                    changeValueTrigger
                                    noBorder={false}
                                    withNewBackground
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <FormLabel>
                                    {t('Is the warden cover 24 hours with a radio?')}
                                </FormLabel>

                                <FormControl>
                                    <RadioGroup
                                        row
                                        name="wardenCover"
                                        onChange={handleChangeRadio}
                                        value={frailtyForm.wardenCover}
                                    >
                                        <FormControlLabel value="yes" control={<Radio/>} label={t('Yes')}/>
                                        <FormControlLabel value="no" control={<Radio/>} label={t('No')}/>
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </>
                    }

                    {frailtyForm.liveIn === 'otherLiveIn' &&
                        <Grid item xs={12}>
                            <FormLabel className={frailtyForm.liveInOtherDetails ? classes.label : classes.mandatory}>
                                {t('Provide further information:')}
                                {!frailtyForm.liveInOtherDetails && '*'}
                            </FormLabel>

                            <AgyleTextField
                                fullWidth
                                name="liveInOtherDetails"
                                // className={classes.input}
                                maxRows={25}
                                multiline
                                onChange={handleChangeTextField}
                                value={frailtyForm.liveInOtherDetails}
                                variant="outlined"
                                error={!frailtyForm.liveInOtherDetails}
                                noBorder={false}
                                withNewBackground
                            />
                        </Grid>
                    }

                    <Divider className={classes.divider}/>

                    <Grid item xs={12} className={classes.blockSwitch}>
                        <FormLabel>
                            {t('Has this been Adapted?')}
                        </FormLabel>

                        <AgyleBlockSwitch
                            value={frailtyForm.beenAdapted}
                            onChange={() => handleChangeBlockSwitch('beenAdapted')}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <FormLabel>
                            {t('Describe Adaptations e.g stairlift, grab rails, adapted to downstairs living')}
                        </FormLabel>

                        <TextFieldDebounce
                            // disabled={isFormDisabled}
                            name="beenAdaptedDetails"
                            maxRows={25}
                            multiline
                            agyleRefresh
                            fullWidth
                            onChange={handleChangeTextField}
                            value={frailtyForm.beenAdaptedDetails}
                            variant="outlined"
                            changeValueTrigger
                            noBorder={false}
                            withNewBackground
                        />
                    </Grid>

                    <Divider className={classes.divider}/>

                    <Grid item xs={12} className={classes.blockSwitch}>
                        <FormLabel>
                            {t('Housebound?')}
                        </FormLabel>

                        <AgyleBlockSwitch
                            value={frailtyForm.housebound}
                            onChange={() => handleChangeBlockSwitch('housebound')}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <FormLabel className={frailtyForm.houseboundDetails ? classes.label : classes.mandatory}>
                            {t('Provide further information:')}
                            {!frailtyForm.houseboundDetails && '*'}
                        </FormLabel>

                        <AgyleTextField
                            fullWidth
                            name="houseboundDetails"
                            // className={classes.input}
                            maxRows={25}
                            multiline
                            onChange={handleChangeTextField}
                            value={frailtyForm.houseboundDetails}
                            variant="outlined"
                            error={!frailtyForm.houseboundDetails}
                            noBorder={false}
                            withNewBackground
                        />
                    </Grid>

                    <Divider className={classes.divider}/>

                    <Grid item xs={12} className={classes.blockSwitch}>
                        <FormLabel>
                            {t('Carer(s) in place?')}
                        </FormLabel>

                        <AgyleBlockSwitch
                            value={frailtyForm.carers}
                            onChange={() => handleChangeBlockSwitch('carers')}
                        />
                    </Grid>

                    {frailtyForm.carers === true &&
                        <>
                            <Grid container item xs={12} className={classes.provideDetailsLabel}>
                                <Grid item xs={12}>
                                    <FormLabel className={classes.label}>
                                        {t('Who provides care?')}
                                    </FormLabel>
                                </Grid>

                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                onChange={(event) => handleChangeCheckbox(event, 'whoProvideCare')}
                                                checked={frailtyForm.whoProvideCare.formal}
                                                name="formal"
                                            />
                                        }
                                        label={t('Formal')}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                onChange={(event) => handleChangeCheckbox(event, 'whoProvideCare')}
                                                checked={frailtyForm.whoProvideCare.privatelyFunded}
                                                name="privatelyFunded"
                                            />
                                        }
                                        label={t('Privately Funded')}
                                    />
                                </Grid>

                                <Grid item xs={3}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                onChange={(event) => handleChangeCheckbox(event, 'whoProvideCare')}
                                                checked={frailtyForm.whoProvideCare.informal}
                                                name="informal"
                                            />
                                        }
                                        label={t('Informal')}
                                    />
                                </Grid>

                                <Grid item xs={9}>
                                    {frailtyForm.whoProvideCare.informal &&
                                        <TextFieldDebounce
                                            // disabled={isFormDisabled}
                                            name="informalDetails"
                                            maxRows={25}
                                            label={t('Provide details...')}
                                            fullWidth
                                            multiline
                                            agyleRefresh
                                            onChange={handleChangeTextField}
                                            value={frailtyForm.informalDetails}
                                            variant="outlined"
                                            changeValueTrigger
                                            noBorder={false}
                                            withNewBackground
                                        />
                                    }
                                </Grid>

                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                onChange={(event) => handleChangeCheckbox(event, 'whoProvideCare')}
                                                checked={frailtyForm.whoProvideCare.familyFriends}
                                                name="familyFriends"
                                            />
                                        }
                                        label={t('Family/Friends')}
                                    />
                                </Grid>

                                <Grid item xs={3}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                onChange={(event) => handleChangeCheckbox(event, 'whoProvideCare')}
                                                checked={frailtyForm.whoProvideCare.other}
                                                name="other"
                                            />
                                        }
                                        label={t('Other')}
                                    />
                                </Grid>

                                <Grid item xs={9}>
                                    {frailtyForm.whoProvideCare.other && (
                                        <>
                                            <FormLabel
                                                className={frailtyForm.otherProvideCareSpecify ? classes.label : classes.mandatory}>
                                                {t('Provide further information:')}
                                                {!frailtyForm.otherProvideCareSpecify && '*'}
                                            </FormLabel>

                                            <TextFieldDebounce
                                                // disabled={isFormDisabled}
                                                name="otherProvideCareSpecify"
                                                maxRows={25}
                                                fullWidth
                                                multiline
                                                agyleRefresh
                                                onChange={handleChangeTextField}
                                                value={frailtyForm.otherProvideCareSpecify}
                                                variant="outlined"
                                                changeValueTrigger
                                                noBorder={false}
                                                withNewBackground
                                            />
                                        </>
                                    )}
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <FormLabel>
                                    {t('How often is the care provided? (days of the week,times etc)')}
                                </FormLabel>

                                <TextFieldDebounce
                                    // disabled={isFormDisabled}
                                    name="careFrequency"
                                    maxRows={25}
                                    multiline
                                    agyleRefresh
                                    fullWidth
                                    onChange={handleChangeTextField}
                                    value={frailtyForm.careFrequency}
                                    variant="outlined"
                                    changeValueTrigger
                                    noBorder={false}
                                    withNewBackground
                                />
                            </Grid>
                        </>
                    }
                </Grid>
            </AgyleAccordion>

            <AgyleAccordion
                expanded={accordionExpandedState.mobility}
                onChange={() => handleChangeAccordion('mobility')}
                label="Mobility"
                formBackground
            >
                <Grid container item xs={12} className={classes.provideDetailsLabel}>
                    <Grid item xs={12}>
                        <FormLabel>
                            {t('Patient / Patient is / Patient uses')}
                        </FormLabel>
                    </Grid>

                    <Divider className={classes.divider}/>

                    <Grid item xs={3}>
                        <FormLabel>
                            {t('Mobility')}
                        </FormLabel>
                    </Grid>

                    <Grid item xs={9}>
                        <FormControl className={classes.radio}>
                            <RadioGroup
                                row
                                name="patient"
                                onChange={handleChangeRadio}
                                value={frailtyForm.patient}
                            >
                                <FormControlLabel
                                    value="bedbound"
                                    control={<Radio/>}
                                    label={t('Bedbound')}
                                />

                                <FormControlLabel
                                    value="independent"
                                    control={<Radio/>}
                                    label={t('Independent')}
                                />

                                <FormControlLabel
                                    value="furnitureWalks"
                                    control={<Radio/>}
                                    label={t('Furniture walks')}
                                />

                                <FormControlLabel
                                    value="transfersOnly"
                                    control={<Radio/>}
                                    label={t('Transfers only')}
                                />
                            </RadioGroup>
                        </FormControl>

                        {frailtyForm.patient === 'transfersOnly' &&
                            <>
                                <FormControl>
                                    <RadioGroup
                                        row
                                        name="withHelpOf"
                                        onChange={handleChangeRadio}
                                        value={frailtyForm.withHelpOf}
                                    >
                                        <FormControlLabel
                                            value="one"
                                            control={<Radio/>}
                                            label={t('One')}
                                        />

                                        <FormControlLabel
                                            value="two"
                                            control={<Radio/>}
                                            label={t('Two')}
                                        />

                                        <FormControlLabel
                                            value="hoist"
                                            control={<Radio/>}
                                            label={t('Hoist')}
                                        />

                                        <FormControlLabel
                                            value="otherWithHelpOf"
                                            control={<Radio/>}
                                            label={t('Other')}
                                        />
                                    </RadioGroup>
                                </FormControl>

                                <TextFieldDebounce
                                    name="withHelpOfDetails"
                                    maxRows={25}
                                    label={t('Provide details...')}
                                    multiline
                                    agyleRefresh
                                    onChange={handleChangeTextField}
                                    value={frailtyForm.withHelpOfDetails}
                                    variant="outlined"
                                    changeValueTrigger
                                    noBorder={false}
                                    withNewBackground
                                />
                            </>
                        }
                    </Grid>

                    <Divider className={classes.divider}/>

                    <Grid item xs={3}>
                        <FormLabel>
                            {t('Mobility aids')}
                        </FormLabel>
                    </Grid>

                    <Grid item xs={8}>
                        <FormControl className={classes.radio}>
                            <RadioGroup
                                row
                                name="patient"
                                onChange={handleChangeRadio}
                                value={frailtyForm.patient}
                            >
                                <FormControlLabel
                                    value="frame"
                                    control={<Radio/>}
                                    label={t('Frame')}
                                />

                                <FormControlLabel
                                    value="rollator"
                                    control={<Radio/>}
                                    label={t('Rollator')}
                                />

                                <FormControlLabel
                                    value="wheelchair"
                                    control={<Radio/>}
                                    label={t('Wheelchair')}
                                />

                                <FormControlLabel
                                    value="other"
                                    control={<Radio/>}
                                    label={t('Other')}
                                />

                                {frailtyForm.patient === 'other' &&
                                    <TextFieldDebounce
                                        // disabled={isFormDisabled}
                                        name="patientOtherDetails"
                                        maxRows={25}
                                        multiline
                                        label="Provide further information"
                                        agyleRefresh
                                        onChange={handleChangeTextField}
                                        value={frailtyForm.patientOtherDetails}
                                        variant="outlined"
                                        changeValueTrigger
                                        noBorder={false}
                                        withNewBackground
                                    />
                                }
                            </RadioGroup>
                        </FormControl>
                    </Grid>

                    <Grid item xs={1}>
                        <Button
                            className={classes.clearButton}
                            onClick={() => handleChangeNull('patient')}
                        >
                            {t('CLEAR')}
                        </Button>
                    </Grid>

                    <Divider className={classes.divider}/>

                    <Grid item xs={3}>
                        <FormLabel>
                            {t('Mobility Outside the home')}
                        </FormLabel>
                    </Grid>

                    <Grid item xs={9}>
                        <FormControl className={classes.radio}>
                            <RadioGroup
                                row
                                name="patient"
                                onChange={handleChangeRadio}
                                value={frailtyForm.patient}
                            >
                                <FormControlLabel
                                    value="mobilityScooter"
                                    control={<Radio/>}
                                    label={t('Mobility scooter')}
                                />

                                <FormControlLabel
                                    value="drives"
                                    control={<Radio/>}
                                    label={t('Drives')}
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                </Grid>
            </AgyleAccordion>

            <AgyleAccordion
                expanded={accordionExpandedState.activity}
                onChange={() => handleChangeAccordion('activity')}
                label="Activity of daily living and who assists"
                formBackground
            >
                <Grid container spacing={2}>
                    <Grid item xs={2}/>

                    <Grid item xs={4}>
                        <FormLabel>
                            {t('Independent?')}
                        </FormLabel>
                    </Grid>

                    <Grid item xs={6}>
                        <FormLabel>
                            {t('Help from (carers / family / friends / other arrangements)')}
                        </FormLabel>
                    </Grid>

                    {renderActivityItems()}
                </Grid>

                <Grid container item xs={12}>
                    {(frailtyForm.liveIn === 'nursingHome' || frailtyForm.liveIn === 'careHome') &&
                        <>
                            <Divider className={classes.divider} style={{margin: '10px 0'}}/>

                            <Grid item xs={6} className={classes.blockSwitch}>
                                <FormLabel>
                                    {t('Does the patient have a ‘This Is Me’ passport?')}
                                </FormLabel>

                                <AgyleBlockSwitch
                                    value={frailtyForm.passport}
                                    onChange={() => handleChangeBlockSwitch('passport')}
                                />
                            </Grid>
                        </>
                    }
                </Grid>
            </AgyleAccordion>

            <AgyleAccordion
                expanded={accordionExpandedState.cognition}
                onChange={() => handleChangeAccordion('cognition')}
                label="Cognition"
                formBackground
            >
                <Grid container spacing={2}>
                    <Grid item xs={6} className={classes.blockSwitch}>
                        <FormLabel>
                            {t('Cognitive impairment? (Please consider patients cognitive baseline)')}
                        </FormLabel>

                        <AgyleBlockSwitch
                            value={frailtyForm.cognitive}
                            onChange={() => handleChangeBlockSwitch('cognitive')}
                        />
                    </Grid>

                    <Grid item xs={6} className={classes.blockSwitch}>
                        <FormLabel>
                            {t('Diagnosis of Dementia?')}
                        </FormLabel>

                        <AgyleBlockSwitch
                            value={frailtyForm.diagnosis}
                            onChange={() => handleChangeBlockSwitch('diagnosis')}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextFieldDebounce
                            // disabled={isFormDisabled}
                            name="cognitiveDetails"
                            maxRows={25}
                            label={t('Provide details...')}
                            multiline
                            agyleRefresh
                            fullWidth
                            onChange={handleChangeTextField}
                            value={frailtyForm.cognitiveDetails}
                            variant="outlined"
                            changeValueTrigger
                            noBorder={false}
                            withNewBackground
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextFieldDebounce
                            // disabled={isFormDisabled}
                            name="diagnosisDetails"
                            maxRows={25}
                            label={t('Provide details...')}
                            multiline
                            agyleRefresh
                            fullWidth
                            onChange={handleChangeTextField}
                            value={frailtyForm.diagnosisDetails}
                            variant="outlined"
                            changeValueTrigger
                            noBorder={false}
                            withNewBackground
                        />
                    </Grid>

                    <Divider className={classes.divider}/>

                    <Grid item xs={12}>
                        <h4>
                            {t('Lasting Power of Attorney')}
                        </h4>
                    </Grid>

                    <Grid item xs={2}>
                        <FormLabel>
                            {t('Health')}
                        </FormLabel>
                    </Grid>

                    <Grid item xs={10}>
                        <FormControl>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="health"
                                onChange={handleChangeRadio}
                                value={frailtyForm.health}
                            >
                                <FormControlLabel
                                    value="yes"
                                    control={<Radio/>}
                                    label={t('Yes')}
                                />

                                <FormControlLabel
                                    value="no"
                                    control={<Radio/>}
                                    label={t('No')}
                                />

                                <Button
                                    className={classes.clearButton}
                                    onClick={() => handleChangeNull('health')}
                                >
                                    {t('CLEAR')}
                                </Button>
                            </RadioGroup>
                        </FormControl>
                    </Grid>

                    {frailtyForm.health === 'yes' &&
                        <>
                            <Grid item xs={4}>
                                <FormLabel>
                                    {t('Who holds lasting power of attorney? Name')}
                                </FormLabel>
                            </Grid>

                            <Grid item xs={2}>
                                <TextFieldDebounce
                                    // disabled={isFormDisabled}
                                    name="powerOfAttorneyHealthYes"
                                    maxRows={25}
                                    multiline
                                    fullWidth
                                    agyleRefresh
                                    onChange={handleChangeTextField}
                                    value={frailtyForm.powerOfAttorneyHealthYes}
                                    variant="outlined"
                                    changeValueTrigger
                                    noBorder={false}
                                    withNewBackground
                                />
                            </Grid>

                            <Grid item xs={1.5}>
                            </Grid>

                            <Grid item xs={2.5}>
                                <FormLabel>
                                    {t('Relationship to the patient')}
                                </FormLabel>
                            </Grid>

                            <Grid item xs={2}>
                                <TextFieldDebounce
                                    // disabled={isFormDisabled}
                                    name="relationshipHealthYes"
                                    maxRows={25}
                                    multiline
                                    fullWidth
                                    agyleRefresh
                                    onChange={handleChangeTextField}
                                    value={frailtyForm.relationshipHealthYes}
                                    variant="outlined"
                                    changeValueTrigger
                                    noBorder={false}
                                    withNewBackground
                                />
                            </Grid>
                        </>
                    }

                    {frailtyForm.health === 'no' &&
                        <>
                            <Grid item xs={5}>
                                <FormLabel>
                                    {t('Name of person stating an Lasting Power of Attorney exists')}
                                </FormLabel>
                            </Grid>

                            <Grid item xs={2}>
                                <TextFieldDebounce
                                    // disabled={isFormDisabled}
                                    name="powerOfAttorneyHealthNo"
                                    maxRows={25}
                                    multiline
                                    fullWidth
                                    agyleRefresh
                                    onChange={handleChangeTextField}
                                    value={frailtyForm.powerOfAttorneyHealthNo}
                                    variant="outlined"
                                    changeValueTrigger
                                    noBorder={false}
                                    withNewBackground
                                />
                            </Grid>

                            <Grid item xs={0.5}>
                            </Grid>

                            <Grid item xs={2.5}>
                                <FormLabel>{t('Relationship to the patient')}</FormLabel>
                            </Grid>

                            <Grid item xs={2}>
                                <TextFieldDebounce
                                    // disabled={isFormDisabled}
                                    name="relationshipHealthNo"
                                    maxRows={25}
                                    multiline
                                    fullWidth
                                    agyleRefresh
                                    onChange={handleChangeTextField}
                                    value={frailtyForm.relationshipHealthNo}
                                    variant="outlined"
                                    changeValueTrigger
                                    noBorder={false}
                                    withNewBackground
                                />
                            </Grid>
                        </>
                    }

                    <Divider className={classes.divider}/>

                    <Grid item xs={2}>
                        <FormLabel>
                            {t('Financial')}
                        </FormLabel>
                    </Grid>

                    <Grid item xs={10}>
                        <FormControl>
                            <RadioGroup
                                row
                                name="financial"
                                onChange={handleChangeRadio}
                                value={frailtyForm.financial}
                            >
                                <FormControlLabel
                                    value="yes"
                                    control={<Radio/>}
                                    label={t('Yes')}
                                />

                                <FormControlLabel
                                    value="no"
                                    control={<Radio/>}
                                    label={t('No')}
                                />

                                <Button
                                    className={classes.clearButton}
                                    onClick={() => handleChangeNull('financial')}
                                >
                                    {t('CLEAR')}
                                </Button>
                            </RadioGroup>
                        </FormControl>
                    </Grid>

                    {frailtyForm.financial === 'yes' &&
                        <>
                            <Grid item xs={4}>
                                <FormLabel>
                                    {t('Who holds lasting power of attorney? Name')}
                                </FormLabel>
                            </Grid>

                            <Grid item xs={2}>
                                <TextFieldDebounce
                                    // disabled={isFormDisabled}
                                    name="powerOfAttorneyFinancialYes"
                                    maxRows={25}
                                    multiline
                                    fullWidth
                                    agyleRefresh
                                    onChange={handleChangeTextField}
                                    value={frailtyForm.powerOfAttorneyFinancialYes}
                                    variant="outlined"
                                    changeValueTrigger
                                    noBorder={false}
                                    withNewBackground
                                />
                            </Grid>

                            <Grid item xs={1.5}>
                            </Grid>

                            <Grid item xs={2.5}>
                                <FormLabel>{t('Relationship to the patient')}</FormLabel>
                            </Grid>

                            <Grid item xs={2}>
                                <TextFieldDebounce
                                    // disabled={isFormDisabled}
                                    name="relationshipFinancialYes"
                                    maxRows={25}
                                    multiline
                                    fullWidth
                                    agyleRefresh
                                    onChange={handleChangeTextField}
                                    value={frailtyForm.relationshipFinancialYes}
                                    variant="outlined"
                                    changeValueTrigger
                                    noBorder={false}
                                    withNewBackground
                                />
                            </Grid>
                        </>
                    }

                    {frailtyForm.financial === 'no' &&
                        <>
                            <Grid item xs={5}>
                                <FormLabel>
                                    {t('Name of person stating an Lasting Power of Attorney exists')}
                                </FormLabel>
                            </Grid>

                            <Grid item xs={2}>
                                <TextFieldDebounce
                                    // disabled={isFormDisabled}
                                    name="powerOfAttorneyFinancialNo"
                                    maxRows={25}
                                    multiline
                                    fullWidth
                                    agyleRefresh
                                    onChange={handleChangeTextField}
                                    value={frailtyForm.powerOfAttorneyFinancialNo}
                                    variant="outlined"
                                    changeValueTrigger
                                    noBorder={false}
                                    withNewBackground
                                />
                            </Grid>

                            <Grid item xs={0.5}>
                            </Grid>

                            <Grid item xs={2.5}>
                                <FormLabel>
                                    {t('Relationship to the patient')}
                                </FormLabel>
                            </Grid>

                            <Grid item xs={2}>
                                <TextFieldDebounce
                                    // disabled={isFormDisabled}
                                    name="relationshipFinancialNo"
                                    maxRows={25}
                                    multiline
                                    fullWidth
                                    agyleRefresh
                                    onChange={handleChangeTextField}
                                    value={frailtyForm.relationshipFinancialNo}
                                    variant="outlined"
                                    changeValueTrigger
                                    noBorder={false}
                                    withNewBackground
                                />
                            </Grid>
                        </>
                    }

                    <Divider className={classes.divider}/>

                    <Grid item xs={5.5}>
                        <FormLabel>
                            {t('Who is the person providing information with radio buttons for?')}
                        </FormLabel>
                    </Grid>

                    <Grid item xs={6.5}>
                        <FormControl>
                            <RadioGroup
                                row
                                name="personProvidingInformation"
                                onChange={handleChangeRadio}
                                value={frailtyForm.personProvidingInformation}
                            >
                                <FormControlLabel
                                    value="patient"
                                    control={<Radio/>}
                                    label={t('Patient')}
                                />

                                <FormControlLabel
                                    value="carer"
                                    control={<Radio/>}
                                    label={t('Carer')}
                                />

                                <FormControlLabel
                                    value="relative"
                                    control={<Radio/>}
                                    label={t('Relative')}
                                />

                                <FormControlLabel
                                    value="spouse"
                                    control={<Radio/>}
                                    label={t('Spouse')}
                                />

                                <FormControlLabel
                                    value="other"
                                    control={<Radio/>}
                                    label={t('Other')}
                                />

                                <Button
                                    className={classes.clearButton}
                                    onClick={() => handleChangeNull('personProvidingInformation')}
                                >
                                    {t('CLEAR')}
                                </Button>
                            </RadioGroup>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        {frailtyForm.personProvidingInformation === 'other' &&
                            <>
                                <FormLabel
                                    className={frailtyForm.personProvidingInformationOther ? classes.label : classes.mandatory}
                                >
                                    {t('Provide further information:')}
                                    {!frailtyForm.personProvidingInformationOther && '*'}
                                </FormLabel>

                                <TextFieldDebounce
                                    // disabled={isFormDisabled}
                                    name="personProvidingInformationOther"
                                    maxRows={25}
                                    multiline
                                    fullWidth
                                    agyleRefresh
                                    onChange={handleChangeTextField}
                                    value={frailtyForm.personProvidingInformationOther}
                                    variant="outlined"
                                    changeValueTrigger
                                    noBorder={false}
                                    withNewBackground
                                />
                            </>
                        }
                    </Grid>
                </Grid>
            </AgyleAccordion>
        </>
    );
};

export default FrailtyForm;